/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from "formik";

import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import SelectField from 'components/Form/SelectField';
import FileModal from 'components/FileModal';
import DialogComponent from "components/Dialog";

import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, DialogCancel, DialogConfirm, DialogSelect, ButtonContent, PlaceHolder, TagInput } from './styles';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import {useHeaderNbi, useMRCModal, useGenerateWording} from 'services/QuoteService';


export default function SendMrcRequest(props) {

    const [summary, setSummary] = useState({});
    const [file, setFile] = useState();
    const [historymsg, setHistorymsg] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [isDisable, setIsDisable] = useState(true);
    const [editUrl, setEditUrl] = useState("");

    const history = useHistory();
    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    fitinsur.setAuthToken(authContext.token);

    const {
        data: useHeaderNbiData,
        loading: useHeaderNbiLoading,
        error: useHeaderNbiError,
        status: useHeaderNbiStatus,
        request: useHeaderNbiRequest,
      } = useHeaderNbi();

      const {
        data: useMRCModalData,
        loading: useMRCModalLoading,
        error: useMRCModalError,
        status: useMRCModalStatus,
        request: useMRCModalRequest,
      } = useMRCModal(props.match.params.idOperation);

      const {
        data: useGenerateWordingData,
        loading: useGenerateWordingLoading,
        error: useGenerateWordingError,
        status: useGenerateWordingStatus,
        request: useGenerateWordingRequest,
      } = useGenerateWording(props.match.params.idOperation);

      useEffect(() => {
        if (useHeaderNbiLoading || useMRCModalLoading || useGenerateWordingLoading) {
          loading.start();
        } else {
          loading.stop();
        }
      }, [useHeaderNbiLoading, useMRCModalLoading, useGenerateWordingLoading]);

    //////////// Lost Dialog ///////////////// 
    const [lostDeal, setLostDeal] = useState({
        formated: [],
        array: [],
    });
    const [dialog, setDialog] = useState({
        visible: false,
        title: "",
        icon: "times-circle",
        args: null,
    });

    const requestLostDealList = () => {

        fitinsur.requestLostDealList()
            .then((response) => {
                return response.json();
            })
            .then((data) => {

                if (data.ret_value) {
                    const lista = [];
                    for (let index = 0; index < data.ret_value.length; index++) {
                        lista.push({ label: data.ret_value[index].ANSWER_OPTION_DESCRIPTION, value: data.ret_value[index].ID_ANSWER_OPTION })

                    }
                    setLostDeal({ formated: lista, array: data.ret_value });

                } else {
                    mc.error("fitGetLostReason - UNEXPECTED RETURNED DATA => " + JSON.stringify(data));
                    setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
                }


            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${requestLostDealList.name}\n` + error);
                console.error('fitGetLostReason - Error:', error);
                setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
            });
    }
    const HandleLostSubmit = (selectedID, array, argsContext) => {
        console.log(selectedID, array, argsContext);
        fitinsur.setAuthToken(authContext.token);
        fitinsur.updateQuoteEdit(props.match.params.idOperation, selectedID.reasons).then(x => x.json()).then(res => {
            console.log(res)
            if (res.ret_code != 200) {
                mc.error(res.ret_msg_details);
                return;
            }
            setDialog({ visible: false, title: null, icon: null, args: null });
            history.push('/list');
        })
    };
    ////////////////////////////////////////

    /*async function getEditUrl() {
        loading.start();

        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestGetEditWordingUrl(props.match.params.idOperation).
            then(data => data.json()).
            then(resp => {
                if (resp.ret_code !== 200) {
                    mc.error(resp.ret_msg_details);
                    loading.stop();
                    return;
                }
                setEditUrl(resp.ret_value);
            }).
            catch((error) => {
                mc.error(`There was an error while fetching your data: ${getEditUrl.name}\n` + error);
                console.error('fitPostFiles - Error:', error);
                loading.stop();
            });
    }*/

    /*function handleGetFiles() {
        loading.start();

        fitinsur.requestGetDocuments(props.match.params.idOperation)
            .then(data => data.json())
            .then(response => {
                const files = response.ret_value;
                let aux = [];

                files.forEach(file => {
                    let obj = {
                        dsTypeDocument: "Attachment",
                        nameDocument: file.nameDocument,
                        idTypeDocument: file.idTypeDocument,
                        nameFile: file.nameFile,
                        size: file.size,
                        type: file.type,
                        urlLink: file.urlLink,
                        idDocument: file.idDocument
                    };
                    aux.push(obj);
                });
                setAttachments(aux);
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
                console.error('fitPostFiles - Error:', error);
            });
        loading.stop();
    }*/

    const goToLoginPage = () => {
        history.push('/login');
    };

    //carregar o arquivo pdf do MRC 
    function handleModal() {
        useMRCModalRequest().then(({data}) => {
                //setFile(data);
                let json = data;
                /*// =================================================
                // 20201107 - MRC modal returning only MRC1 document
                //let mrc1={
                //    title: "MRC Part 1",
                //    html: json.ret_value
                //};
                //setFile([mrc1]);
                // =================================================
                // 20201108 - MRC modal returning array of MRC1/MRC2
                let mrcDocs=[];
                if (json.ret_value && json.ret_value.length>0){
                    json.ret_value.forEach((element) => {
                        mrcDocs.push({
                            title: element.ret_msg,
                            html: element.ret_value
                        });
                    });
                }
                setFile(mrcDocs);
                // =================================================*/
                if (json.ret_value && json.ret_value.length>0){
                    setFile(json.ret_value);
                }else{
                    setFile([]);
                }
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleModal.name}\n` + error);
                console.error('fitPostFiles - Error:', error);
            });
    };

    async function handleSummary() {
        useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }
                setSummary({
                    typeOfCover: data.ret_value.typeOfCover,
                    client: data.ret_value.client,
                    obligorCoding: data.ret_value.obligorCoding,
                    responseBy: data.ret_value.responseBy,
                    internalContact: data.ret_value.internalContact,
                    broker: data.ret_value.broker,
                    dealCode: data.ret_value.deal,
                    nmFacility: data.ret_value.nmFacility,
                    nmObligor: data.ret_value.nmObligor,
                    projectName: data.ret_value.projectName,
                });
                setHistorymsg(data.ret_value.historical);
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
                console.error('fitPostSummary - Error:', error);
            });
    };

    function handleDialog() {
        setDialog({
            visible: true,
            title: "LOST DEAL",
            icon: "TimesCircle",
            args: null,
        })
        requestLostDealList();
    };

    function handleBack() {
        history.goBack();
    };

    function handleMktCompostion() {
        history.push(`/broking/market-composition/${props.match.params.idOperation}`)
    };

    function handleWording() {
        useGenerateWordingRequest().then(({data: resp}) => {
            if (resp.ret_code !== 200) {
              mc.error(resp.ret_msg_details);
              return;
            }
            history.push(`/broking/send-wording-request/${props.match.params.idOperation}`);
          })
          .catch();
      };
          
    useEffect(() => {
        fitinsur.setAuthToken(authContext.token);

        handleModal();
        handleSummary();
        //handleGetFiles();
        //getEditUrl();
    }, [])

    return (
        <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
              <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
            <Scrollbox>
                <BrokingSummary data={summary ? summary : ''} />
                <ContentCard title="Generate MRC" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                    <DialogComponent
                        icon={dialog.icon}
                        title={dialog.title}
                        
                        show={dialog.visible}
                        setDialog={setDialog}>
                        <Formik
                            initialValues={{ reasons: "" }}
                            onSubmit={(e) => HandleLostSubmit(e, lostDeal.array, dialog.args)}>
                            <Form>
                                <DialogSelect>
                                    <Field
                                        name="reasons"
                                        placeholder="Select the reason the deal was lost"
                                        component={SelectField}
                                        options={lostDeal.formated}
                                    />
                                </DialogSelect>
                                <DialogCancel
                                    onClick={() => {
                                        setDialog({
                                            visible: false,
                                            title: null,
                                            icon: null,
                                            args: null,
                                        });
                                    }}>
                                    Cancel
                                </DialogCancel>
                                <DialogConfirm type="submit">Confirm</DialogConfirm>
                            </Form>
                        </Formik>
                    </DialogComponent>
                    <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                    <ButtonContainer>
                        <Button forth onClick={() => handleBack()}>&lt; Back</Button>
                        <RenderButtons idOperation={props.match?.params?.idOperation}>
                            <ButtonContent>
                                <Button style={{ marginLeft: "10px", marginTop: "5px" }} secundary onClick={() => handleDialog()}>
                                    LOST
                                </Button>
                                <Button third style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => handleMktCompostion()}>
                                    CDR
                                </Button>
                                <Button primary style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => handleWording()}>
                                    GENERATE WORDING
                                </Button>
                            </ButtonContent>
                        </RenderButtons>
                    </ButtonContainer>
                </ContentCard>
            </Scrollbox>
        </Layout >
    )
}
